import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import { filter, from, map, toArray } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { AudioRecordingService } from 'src/app/Service/audio-recording.service';
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({
  selector: 'app-offline-vehicles',
  templateUrl: './offline-vehicles.component.html',
  styleUrls: ['./offline-vehicles.component.css'],
})
export class OfflineVehiclesComponent implements OnInit {
  bSendPush: boolean = false;
  isAudioRecording: boolean = false;
  bSelectAll: boolean = false;
  bSendPayamak: boolean = false;
  audioRecordedTime: any;
  audioBlobUrl: any = '';
  audioSrcUrl: any = '';
  audioBlob: any;
  audioName: any;
  lst_Expired: any = [];
  lst_Search: any = [];
  @Input() isCalled: boolean = false;
  mdl_Request: FormGroup = this._formBuilder.group({
    strSession: new FormControl(
      this._gurd.decrypt(localStorage.getItem('Session')!),
    ),

    iSystemUser: new FormControl(
      this._gurd.decrypt(localStorage.getItem('ID')!),
    ),

    lststrUnitIDs: new FormControl('', Validators.required),

    strTitle: new FormControl('', Validators.required),

    strMessage: new FormControl(''),

    strVoice: new FormControl(''),

    iPushType: new FormControl(''),

    bSMS: new FormControl(false),

    strDate: new FormControl(
      moment().subtract(1, 'day').format('jYYYY/jMM/jDD'),
    ),

    tiType: new FormControl('4'),
  });

  constructor(
    private _tooltip: NotificationService,

    private _formBuilder: FormBuilder,

    private _gurd: GurdServiceService,

    public _other: OtherService,

    private _router: Router,

    public gurdService: GurdServiceService,

    private audioRecordingService: AudioRecordingService,

    private sanitizer: DomSanitizer,

    private ref: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.fetchOfflineCars();

    var data = window.localStorage.getItem('menu') as any;

    this.bSendPush = JSON.parse(
      this.gurdService.decrypt(data),
    ).bSendPush2MobilesUser;

    this.bSendPayamak = JSON.parse(
      this.gurdService.decrypt(data),
    ).bSendSMS2Driver;

    this.audioRecordingService.getRecordedBlob().subscribe((data) => {
      var base64 = this.blobToBase64(data.blob);

      base64.then((result: any) => {
        result = result.replace('data:audio/wav;base64,', '');

        this.mdl_Request.get('strVoice')?.setValue(result);
      });

      this.audioBlob = data.blob;

      this.audioName = data.title;

      this.audioBlobUrl = this.sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(data.blob),
      );

      this.ref.detectChanges();
    });

    this.audioRecordingService.recordingFailed().subscribe(() => {
      this.isAudioRecording = false;

      this.ref.detectChanges();
    });

    this.audioRecordingService.getRecordedTime().subscribe((time) => {
      this.audioRecordedTime = time;

      if (time == '00:21') {
        this.stopAudioRecording();

        this._tooltip.showError('حده اکثر زمان ضبط صدا 20 ثانیه است');
      }

      this.ref.detectChanges();
    });
  }

  fetchOfflineCars = async () => {
    let model = this.mdl_Request.value;

    this._other.Showspinner();

    let res = JSON.parse(
      (
        await axios.post(
          `Mobiles_Off_List`,
          this._other.stringNumberToNumber(model),
        )
      ).data.toString(),
    );

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Expired = res;

    this.lst_Search = res;
  };

  filter_Result(val: any) {
    this.lst_Expired = this.lst_Search.filter((el: any) => {
      return (
        el.strFullName.toString().includes(val.value) ||
        el.strMobileDomain_strComment?.includes(val.value) ||
        el.strMobile.includes(val.value)
      );
    });

    if (val.value.length == 0) {
      this.lst_Expired = this.lst_Search;
    }
  }

  openPush_User() {
    if (!this.lst_Expired.length)
      return this._tooltip.showError('خودرویی موجود نیست!');

    const selectedUser = from(this.lst_Expired).pipe(
      filter((el: any) => el?.bChosen && el.bChosen),
      map((el: any) => el.strUnitID),
      toArray(),
    );

    selectedUser.subscribe(async (data) => {
      const lstUnitID = data;

      if (!lstUnitID.length)
        return this._tooltip.showError('لیست انتخابی شما خالی می باشد');

      this.mdl_Request.patchValue({
        lststrUnitIDs: lstUnitID,

        iPushType: 0,
      });

      $('#Push_Modal').modal('show');
    });
  }

  changeRoute(item: any) {
    let URL = `/carInfo/${item.strUnitID}`;

    window.open(URL, '_blank');
  }

  onCheckbox_Car(event: any, index: number | string, target?: 'select-all') {
    if (target) {
      if (!this.bSelectAll) {
        this.lst_Expired.forEach((a: any) => {
          a.bChosen = true;
        });

        this._tooltip.showSuccess('همه خودروها با موفقیت انتخاب شدند');

        this.bSelectAll = true;
      } else {
        this.lst_Expired.forEach((a: any) => {
          a.bChosen = false;
        });

        this.bSelectAll = false;
      }
    } else {
      event.stopPropagation();

      this.lst_Expired[index].bChosen = event.target?.checked;
    }
  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'تمدید اعتبار خودروها.xlsx');
  }

  ///AudioHandler
  startAudioRecording() {
    navigator.mediaDevices
      .getUserMedia({ audio: true })

      .then((stream) => {
        if (!this.isAudioRecording) {
          this.isAudioRecording = true;

          this.audioRecordingService.startRecording();
        }
      })
      .catch((err) => {
        if (err.message == 'Requested device not found') {
          this._tooltip.showError('سیستم شما دارای میکروفون نمی باشد');
        } else {
          alert('خطا در ضبظ صدا');
        }
      });
  }

  abortAudioRecording() {
    if (this.isAudioRecording) {
      this.isAudioRecording = false;

      this.audioRecordingService.abortRecording();
    }
  }

  clearAudioRecordedData() {
    this.mdl_Request.get('strVoice')?.setValue('');

    this.audioBlobUrl = null;

    this.audioSrcUrl = '';

    this._tooltip.showSuccess('صدا با موفقیت حذف شد');
  }

  stopAudioRecording() {
    if (this.isAudioRecording) {
      this.audioRecordingService.stopRecording();

      this.isAudioRecording = false;

      this.mdl_Request.get('strMessage')?.setValue('');

      this.mdl_Request.get('tiType')?.setValue('4');

      this.playAudio();
    }
  }

  blobToBase64(blob: any) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();

      reader.onloadend = () => resolve(reader.result);

      reader.readAsDataURL(blob);
    });
  }

  isAudioRecorded(): boolean {
    return this.mdl_Request.get('strVoice')?.value != '' ? true : false;
  }

  playAudio() {
    setTimeout(() => {
      this.audioSrcUrl = this.sanitizer.bypassSecurityTrustUrl(
        `data:audio/mp3;base64,` + this.mdl_Request.get('strVoice')?.value,
      );
    }, 200);
  }

  sendPush_4Users = async () => {
    if (this.mdl_Request.invalid)
      return this._tooltip.showError('عنوان را وارد کنید');

    if (
      this.mdl_Request.get('iPushType')?.value == 1 &&
      this.mdl_Request.get('strMessage')?.value.trim() == ''
    )
      return this._tooltip.showError('متن پیام را وارد کنید');

    if (
      this.mdl_Request.get('iPushType')?.value == 2 &&
      this.mdl_Request.get('strVoice')?.value == ''
    )
      return this._tooltip.showError('صدا را ضبط کنید');
    else {
      if (this.mdl_Request.get('iPushType')?.value == 2) {
        this.mdl_Request.get('strMessage')?.setValue('');

        this.mdl_Request.get('tiType')?.setValue('4');
      }

      if (this.mdl_Request.get('iPushType')?.value == 1) {
        this.mdl_Request.get('strVoice')?.setValue('');

        this.mdl_Request.get('tiType')?.setValue('0');
      }

      this._other.Showspinner();

      var model = this._other.stringNumberToNumber(this.mdl_Request.value);

      let response = await axios.post(`SendPush2MobilesSelected`, model);

      this._other.nonespinner();

      let res = JSON.parse(response.data.toString());

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this._tooltip.showSuccess('پیام با موفقیت ارسال شد');

      this.mdl_Request.patchValue({
        lststrUnitIDs: '',

        strTitle: '',

        strMessage: '',

        strVoice: '',
      });

      $('#Push_Modal').modal('hide');
    }
  };
}
